import React from "react";
import { Breadcrumb } from "@gull";
import { useContext } from "react";
import { AppContext } from "app/appContext";
import usePagePermission from "app/hooks/usePagePermission";
import { Helmet } from "react-helmet";

const Dashboard = () => {
  const { user } = useContext(AppContext);

  return (
    <div>
      <Helmet>
        <title>Admin Dashboard</title>
      </Helmet>
      <Breadcrumb
        routeSegments={[{ name: "Dashboard - " + user.name }]}
      ></Breadcrumb>
    </div>
  );
};
export default Dashboard;
